import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Praktisk from "./components/Praktisk";
import Pamelding from "./components/Pamelding";
import Aktiviteter from "./components/Aktiviteter";
import HomeContainer from "./components/HomeContainer";
import About from "./components/About";

import "./i18n";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route exact path="/" element={<App />}></Route>
      <Route path="/" element={<HomeContainer />}>
        {" "}
      </Route>
      <Route path="/praktisk" element={<Praktisk />}>
        {" "}
      </Route>
      <Route path="/pamelding" element={<Pamelding />}>
        {" "}
      </Route>
      <Route path="/aktiviteter" element={<Aktiviteter />}>
        {" "}
      </Route>
      <Route path="/om" element={<About />}>
        {" "}
      </Route>
    </Routes>
  </BrowserRouter>,

  document.getElementById("root")
);
